<template>
    <div class="m-slider-box">
        <div class="m-tv-station">
            <div class="m-tv">
                <div class="m-tv-left">
                    <a
                        class="u-tv-label"
                        href="./tv"
                        target="_blank"
                        @mouseenter="addAni('tv', 'animate__flash')"
                        @mouseleave="resetAni('tv')"
                        ><i :class="ani.tv"></i>魔盒电视台</a
                    >
                    <mini-bread class="u-tv-notice" name="index_events" />
                </div>
                <div class="m-tv-right">
                    <a
                        class="u-tv-weibo u-tv-link"
                        href="https://weibo.com/jx3box"
                        target="_blank"
                        @mouseenter="addAni('weibo', 'animate__rubberBand')"
                        @mouseleave="resetAni('weibo')"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" :class="ani.weibo" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M403.51 247.992c12.189-23.721 13.499-45.899 3.546-63.137-10.316-17.868-31.605-28.033-59.944-28.622-20.81-.427-44.439 4.311-68.131 13.528 8.166-27.851 5.532-49.961-7.876-63.369-16.113-16.113-44.899-16.666-81.056-1.558-33.715 14.088-70.764 40.33-104.325 73.889C35.742 228.706 2.534 286.681.945 326.653A75.672 75.672 0 000 338.441c0 35.793 25.09 69.017 70.648 93.547 43.858 23.617 101.979 36.622 163.656 36.622s119.798-13.005 163.656-36.622c45.558-24.53 70.648-57.754 70.648-93.547.001-34.374-23.032-66.257-65.098-90.449z" fill="#ea533b"/><path d="M260.338 459.932c-61.677 0-119.798-13.005-163.656-36.622-45.558-24.53-70.648-57.754-70.648-93.547 0-3.863.318-7.825.945-11.787 1.589-39.973 34.797-97.947 84.78-147.93 33.227-33.226 69.87-59.27 103.314-73.458-7.854 1.823-16.218 4.566-25.023 8.245-33.715 14.088-70.764 40.33-104.325 73.889C35.742 228.707 2.534 286.682.945 326.654A75.65 75.65 0 000 338.441c0 35.793 25.09 69.017 70.648 93.547 43.858 23.617 101.979 36.622 163.656 36.622 48.616 0 95.016-8.086 133.969-23.074-32.921 9.405-69.744 14.396-107.935 14.396z" fill="#d93c1c"/><path d="M364.19 312.032c-2.568-29.565-22.081-55.61-54.944-73.338-31.681-17.091-72.302-24.49-114.382-20.835-42.079 3.656-80.818 17.949-109.076 40.247-29.314 23.131-44.045 52.151-41.476 81.715 2.569 29.565 22.082 55.61 54.946 73.338 26.389 14.236 58.976 21.748 93.447 21.747 6.913 0 13.905-.302 20.934-.913 42.079-3.654 80.817-17.948 109.075-40.246 29.315-23.131 44.044-52.151 41.476-81.715z" fill="#fff"/><path d="M230.36 425.319a241.87 241.87 0 01-20.934.913c-34.471.001-67.059-7.511-93.447-21.747-32.863-17.729-52.378-43.774-54.946-73.338-2.569-29.564 12.161-58.584 41.476-81.715 5.799-4.575 12.046-8.808 18.665-12.687-12.993 5.932-24.911 13.095-35.388 21.361-29.314 23.131-44.045 52.151-41.476 81.715 2.569 29.565 22.082 55.61 54.946 73.338 26.389 14.236 58.976 21.748 93.447 21.747 6.913 0 13.905-.302 20.934-.913 33.445-2.905 64.771-12.535 90.41-27.559-22.053 10.069-47.206 16.585-73.687 18.885z" fill="#e5e5e5"/><path d="M286.65 312.533c-9.507-39.544-55.55-62.508-102.638-51.189-47.088 11.32-77.661 52.703-68.156 92.249 4.682 19.473 18.156 35.492 37.943 45.105 12.283 5.967 26.102 9.003 40.355 9.003 8.042 0 16.221-.967 24.339-2.918 47.089-11.321 77.664-52.703 68.157-92.25z" fill="#333"/><circle cx="177.898" cy="351.457" r="30.373" fill="#fff"/><g fill="#ffa929"><path d="M373.152 117.153c-7.189 0-13.017 5.828-13.017 13.017 0 7.189 5.828 13.017 13.017 13.017 26.318 0 47.729 21.411 47.729 47.729 0 7.189 5.828 13.017 13.017 13.017s13.017-5.828 13.017-13.017c-.001-40.673-33.091-73.763-73.763-73.763z"/><path d="M364.475 43.39c-3.261 0-6.564.108-9.817.322-9.564.629-16.808 8.893-16.18 18.458.629 9.564 8.9 16.804 18.458 16.18a115.6 115.6 0 017.539-.248c62.206 0 112.813 50.608 112.813 112.813 0 7.606-.759 15.204-2.257 22.581-1.396 6.875 1.691 14.209 7.576 18.025 5.99 3.884 14.111 3.587 19.829-.675 3.388-2.525 5.774-6.307 6.614-10.445a148.538 148.538 0 002.95-29.487c0-81.343-66.18-147.524-147.525-147.524z"/></g><circle cx="234.305" cy="321.085" r="17.356" fill="#fff"/></svg>JX3BOX魔盒
                    </a>
                    <a
                        class="u-tv-bilibili u-tv-link"
                        href="https://space.bilibili.com/2066064028"
                        target="_blank"
                        @mouseenter="addAni('bilibili', 'animate__swing')"
                        @mouseleave="resetAni('bilibili')"
                    >
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" :class="ani.bilibili" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path clip-rule="evenodd" d="M3.733 2.67a.982.982 0 111.363-1.412l2.121 2.046c.06.058.112.122.154.19h3.208a.99.99 0 01.153-.19l2.122-2.046a.982.982 0 011.363 1.413l-.853.823H14a4 4 0 014 4V13a4 4 0 01-4 4H4a4 4 0 01-4-4V7.494a4 4 0 014-4h.586l-.853-.823zM4 5.424a2 2 0 00-2 2v5.647a2 2 0 002 2h10a2 2 0 002-2V7.423a2 2 0 00-2-2H4zm1 3.894a1 1 0 012 0v.894a1 1 0 11-2 0v-.894zm7-1a1 1 0 00-1 1v.894a1 1 0 102 0v-.894a1 1 0 00-1-1z"/></svg>魔盒tivi
                    </a>
                </div>
            </div>
            <div class="m-slider" v-if="ready" id="m-home-slider">
                <div
                    class="u-slider"
                    v-for="(item, i) in data"
                    :key="i"
                    :style="{ backgroundColor: item.bgcolor }"
                    v-reporter="{
                        data: { url: convertUrlToProtocol(item.link) },
                        caller: 'index_slider',
                    }"
                >
                    <a class="u-pic" :href="item.link" :target="target">
                        <img :src="showSlider(item.img)" />
                    </a>
                </div>
            </div>
        </div>
        <div class="m-slider-thumbnail">
            <div
                class="u-thumbnail"
                :class="{ active: active === i }"
                v-for="(item, i) in data"
                :key="i"
                :style="{ backgroundColor: item.bgcolor }"
                @click="setActive(i)"
            >
                <a class="u-pic">
                    <img :src="showThumbnail(item.img)" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { buildTarget, resolveImagePath, getThumbnail, convertUrlToProtocol } from "@jx3box/jx3box-common/js/utils";
import { getConfigBanner } from "@/service/cms";
import Mini_bread from "../content/mini_bread.vue";
export default {
    name: "slider",
    components: {
        "mini-bread": Mini_bread,
    },
    data: function () {
        return {
            data: [],
            active: 0,
            ratio: window.devicePixelRatio || 1,
            w: window.innerWidth,

            ani: {
                tv: "",
                bilibili: "",
                weibo: "",
            },
        };
    },
    computed: {
        ready: function () {
            return this.data && this.data.length && !this.player_status;
        },
        player_status: function () {
            return ~~this.$store.state.config.index_live_status || ~~this.$store.state.config.index_video_status;
        },
        client: function () {
            return this.$store.state.client;
        },
        target: function () {
            return buildTarget();
        },
    },
    methods: {
        renderSlider: function () {
            $("#m-home-slider")
                .slick({
                    infinite: true,
                    autoplay: true,
                    dots: false,
                })
                .on("afterChange", () => {
                    this.active = $("#m-home-slider").slick("slickCurrentSlide");
                });
        },
        setActive: function (index) {
            this.active = index;
            $("#m-home-slider").slick("slickGoTo", index);
        },
        loadData: function () {
            // banner轮播图
            return getConfigBanner({
                client: this.client,
                type: "slider",
                per: 8,
                status: 1,
            }).then((res) => {
                this.data = res.data.data.list;
            });
        },
        init: function () {
            this.loadData().then(() => {
                this.renderSlider();
            });
        },
        showSlider(val) {
            if (this.ratio > 1 && this.w >= 1920) {
                return resolveImagePath(val);
            } else {
                return getThumbnail(val, "index_slider");
            }
        },
        showThumbnail(val) {
            return getThumbnail(val, "index_banner"); //[220, 60]
        },
        addAni(key, val) {
            this.ani[key] = `animate__animated ${val}`;
        },
        resetAni(key) {
            this.ani[key] = "";
        },
        convertUrlToProtocol,
    },
    mounted: function () {
        this.init();
    },
};
</script>

<style lang="less">
@import "../../assets/css/v2/slider.less";
</style>
